import React from 'react';
import "./ChatIntro.css"

export default () => {
    return(
        <div className="chatIntro">
            <img src="https://cdn.discordapp.com/attachments/738892427548557408/927720827825291294/unknown.png" alt="" />
            <h1>Mantenha seu celular conectado</h1>
            <h2>O WhatsApp conecta ao seu telefone para sincronizar suas mensagens.<br/> Para reduzir o uso de dados, conecte seu telefone a um rede Wi-Fi</h2>
        </div>
    )
}